import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import axios from 'axios';
import numeral from 'numeral';
import {
  Table,
  TableHeader,
  TableRow,
  TableHeaderCell,
  TableBody,
  TableCell,
  Header,
  HeaderContent,
  HeaderSubheader,
  Image,
  Icon,
  Label,
} from 'semantic-ui-react';
import _ from 'lodash';
import InfluencerContextBar from '../../components/influencer-context-bar';
import { reportError } from '../../utils/error-handling-service';
const CREATOR_API = 'https://8zvbzkwj5m.execute-api.eu-west-1.amazonaws.com/production/creators/find/xxx';

class MyCreators extends Component {
  static contextTypes = {
    router: PropTypes.object,
  };
  static propTypes = {
    user: PropTypes.object,
    location: PropTypes.object,
  };

  static defaultProps = {
    user: null,
    location: {},
  };

  constructor(props) {
    super(props);
    const defaultApprovalModeEnabled = _.last(_.split(props.location.pathname, '/')) === 'approvals';
    this.state = {
      showTooltip: false,
      filter: {
        platform: 'instagram',
        min: '1000',
        max: '5000',
        country: '',
        maxInstagramEngagementRate: '',
        minInstagramEngagementRate: '1',
        hasEmail: true,
      },
      currentPage: 1,
      sort: {
        field: 'createdDate',
        order: 'DESC',
      },
      defaultApprovalModeEnabled,
      ...this.extractSearchParams(props.location),
      creators: null,
      lastUpdated: null,
      secondsUntilReload: 60,
      isLoading: false,
    };

    // Interval reference for cleanup
    this.refreshInterval = null;
    this.countdownInterval = null;
  }

  async componentDidMount() {
    // Initial data fetch
    await this.fetchCreators();

    // Set up auto-refresh every 60 seconds (60000 milliseconds)
    this.refreshInterval = setInterval(() => {
      this.fetchCreators();
      // Reset countdown when data is refreshed
      this.setState({ secondsUntilReload: 60 });
    }, 60000);

    // Set up countdown timer that updates every second
    this.countdownInterval = setInterval(() => {
      this.setState(prevState => ({
        secondsUntilReload: prevState.secondsUntilReload > 0 ? prevState.secondsUntilReload - 1 : 0,
      }));
    }, 1000);
  }

  componentWillUnmount() {
    // Clear the intervals when component unmounts to prevent memory leaks
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
    }
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
    }
  }

  // Separated fetch logic into its own method for reuse
  fetchCreators = async () => {
    try {
      this.setState({ isLoading: true });
      const creatorResponse = await axios.get(CREATOR_API);
      const creators = creatorResponse.data.body.data.data;

      this.setState({
        creators,
        lastUpdated: new Date(),
        isLoading: false,
      });
      console.log('Data refreshed at:', new Date().toLocaleTimeString());
    } catch (error) {
      console.error('Error fetching creators:', error);
      reportError('CREATOR_FETCH_ERROR', error);
      this.setState({ isLoading: false });
    }
  }

  toggleShowTooltip = showTooltip => this.setState({ showTooltip });

  leftButtonCallback = () => this.context.router.push('/dashboard');

  rightButtonCallback = () => this.context.router.push('/influencer/add');

  extractSearchParams = ({ hash }) => {
    try {
      const data = JSON.parse(decodeURIComponent(hash.slice(1)));
      this.setState(data);
      return data;
    } catch (e) {
      console.error(e);
      reportError('SEARCH_PARSE_ERROR', e);

      return {};
    }
  }

  onSearchParamsChange = newParams => {
    const filter = newParams.filter || this.state.filter;
    const currentPage = newParams.currentPage || this.state.currentPage;
    const sort = newParams.sort || this.state.sort;
    const hash = JSON.stringify(({ filter, currentPage, sort }));
    const { location: { pathname } } = this.props;
    this.context.router.replace({ pathname, hash: `#${hash}` });
    this.setState(newParams);
  };


  render() {
    const { user } = this.props;
    const { filter, currentPage, sort, creators, lastUpdated, secondsUntilReload, isLoading } = this.state;

    return (
      <div className="page">

        <InfluencerContextBar
          organisationName={'ALL'}
          showTooltip={this.state.showTooltip}
          rightButtonLabel="Add A Creator"
          leftButtonLabel="Create A Campaign"
          rightButtonCallback={_.noop}
          // rightButtonCallback={this.rightButtonCallback}
          leftButtonCallback={_.noop}
          // leftButtonCallback={this.leftButtonCallback}
          title="My Creators V2 - AI driven creators"
          hasPrivateLink
        />
        <div className="page-content">
          {
            user &&
            <div>
              <h2>Recently Added Creators</h2>
              <p>This query is returning creators who are in the UK, who are in a <em>Creator Category</em> with more than 1,000 followers.</p>

            </div>
          }
          {
            lastUpdated &&
            <div style={{ marginTop: '10px', marginBottom: '10px', fontSize: '12px', color: '#888' }}>
              Last updated: {lastUpdated.toLocaleTimeString()}
              {isLoading ? (
                <span style={{ marginLeft: '10px' }}>
                  <Icon name="spinner" loading />
                  Loading...
                </span>
              ) : (
                <span style={{ marginLeft: '10px' }}>
                  Next refresh in: {secondsUntilReload} seconds
                  <Icon
                    name="refresh"
                    style={{ marginLeft: '8px', cursor: 'pointer' }}
                    title="Refresh now"
                    onClick={() => this.fetchCreators()}
                  />
                </span>
              )}
            </div>
          }
          {
            creators &&
              <Table basic="very" celled>
                <TableHeader>
                  <TableRow>
                    <TableHeaderCell width={1}>Pic</TableHeaderCell>
                    <TableHeaderCell width={2}>Creator</TableHeaderCell>
                    <TableHeaderCell width={1}>Followers</TableHeaderCell>
                    <TableHeaderCell width={1}>Email</TableHeaderCell>
                    <TableHeaderCell width={2}>Categories</TableHeaderCell>
                    <TableHeaderCell width={3}>Keywords</TableHeaderCell>
                    <TableHeaderCell width={4}>Summary</TableHeaderCell>
                    <TableHeaderCell width={2}>Discovered</TableHeaderCell>
                  </TableRow>
                </TableHeader>

                <TableBody>
                  {
                    _.map(creators, creator => (
                      <TableRow key={creator.instagram || creator.id}>
                        <TableCell width={1}>
                          <Image src={creator.thumbnail} rounded size="tiny" />
                        </TableCell>

                        <TableCell width={2}>
                          <Header as="h4" image>
                            <HeaderContent>
                              {creator.name}
                              <HeaderSubheader>
                                <a href={`https://instagram.com/${creator.instagram}`} target="_blank" rel="noopener noreferrer">
                                  {creator.instagram}
                                </a>
                              </HeaderSubheader>
                            </HeaderContent>
                          </Header>
                        </TableCell>
                        <TableCell width={1}>{numeral(creator.instagramCount).format('0,0')}</TableCell>
                        <TableCell width={1}>{creator.email}</TableCell>
                        <TableCell width={2}>
                          <h4>{creator.instagramCategory}</h4>
                          {_.map(creator.contentCategories, cc => (
                            <Label>{cc}</Label>
                          ))}
                        </TableCell>
                        <TableCell width={3}>{_.join(creator.keywords, ', ')}</TableCell>
                        <TableCell width={4}>{creator.summary}</TableCell>
                        <TableCell width={2}>{creator.createdDate}</TableCell>
                      </TableRow>
                    ))

                  }
                </TableBody>
              </Table>

          }
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user.user,
});

export default connect(mapStateToProps)(MyCreators);



/** WEBPACK FOOTER **
 ** ./src/containers/my-creators2/index.js
 **/